// extracted by mini-css-extract-plugin
module.exports = {"products":"OrderUserDetail_products__3a-Ab"};